import { FiltersState } from './types';
import { hirePropertyTypeOptions } from '../bond-insurance-budget-form/types';

export const propertiesWalletLabel = 'Carteira de imóveis';
export const propertiesWalletSectionLabel = 'Imóveis';

export const walletPropertyTypeOptions = hirePropertyTypeOptions.map(option => ({
  key: String(option.key),
  value: String(option.value),
  text: String(option.text),
}));

export const orderByOptions = [
  { key: 'updated_at', value: 'updated_at', text: 'Última atualização' },
  { key: 'id', value: 'id', text: 'Mais recentes' },
  { key: 'area', value: 'area', text: 'Área' },
  { key: 'score', value: 'score', text: 'Score' }
];

export const orderByDirOptions = [
  { key: 'DESC', value: 'DESC', text: 'Decrescente' },
  { key: 'ASC', value: 'ASC', text: 'Crescente' }
];

export const buildInitialFilters = (defaultEstateId = ''): FiltersState => ({
  estateId: defaultEstateId,
  search: '',
  type: '',
  orderBy: 'updated_at',
  orderByDir: 'DESC'
});
